import { render, staticRenderFns } from "./nutritionReports.vue?vue&type=template&id=5db3e654&"
import script from "./nutritionReports.vue?vue&type=script&lang=js&"
export * from "./nutritionReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports